import { TELEMOVEL_GERAL_E164 } from "../data/clinics";

const MENSAGEM_PREDEFINIDA = encodeURIComponent(
  "Olá! Gostaria de saber mais informações sobre a Vet Clinic."
);

export default function WhatsAppFloat() {
  const numero = TELEMOVEL_GERAL_E164.replace("+", "");
  const url = `https://wa.me/${numero}?text=${MENSAGEM_PREDEFINIDA}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar connosco no WhatsApp"
      data-testid="whatsapp-float"
      className="group fixed bottom-5 right-5 md:bottom-7 md:right-7 z-50 grid place-items-center h-14 w-14 md:h-16 md:w-16 rounded-full bg-[#25D366] text-white shadow-[0_12px_30px_-8px_rgba(37,211,102,0.55)] hover:scale-110 active:scale-95 transition-transform"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" aria-hidden />
      {/* WhatsApp SVG */}
      <svg
        viewBox="0 0 32 32"
        className="relative h-7 w-7 md:h-8 md:w-8"
        fill="currentColor"
        aria-hidden
      >
        <path d="M19.11 17.39c-.27-.13-1.59-.78-1.84-.87-.25-.09-.43-.13-.61.14-.18.27-.7.86-.86 1.04-.16.18-.32.2-.59.07-.27-.13-1.13-.42-2.15-1.33-.79-.71-1.33-1.58-1.49-1.85-.16-.27-.02-.41.12-.55.12-.12.27-.32.41-.48.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.48-.07-.13-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34s-.95.93-.95 2.27 1 2.64 1.13 2.83c.13.18 1.94 2.96 4.71 4.15.66.29 1.17.46 1.57.59.66.21 1.26.18 1.74.11.53-.08 1.59-.65 1.81-1.28.22-.63.22-1.18.16-1.28-.07-.11-.25-.18-.52-.31zM16.03 5.33c-5.91 0-10.71 4.79-10.71 10.71 0 1.89.49 3.74 1.42 5.36L5 27.33l6.07-1.59a10.69 10.69 0 0 0 4.96 1.26h.01c5.9 0 10.71-4.8 10.71-10.71 0-2.86-1.11-5.55-3.14-7.58a10.62 10.62 0 0 0-7.58-3.38zm6.23 16.94a8.9 8.9 0 0 1-6.23 2.59h-.01a8.93 8.93 0 0 1-4.55-1.25l-.32-.19-3.6.94.96-3.51-.21-.34a8.9 8.9 0 0 1-1.36-4.74c0-4.92 4.01-8.92 8.93-8.92a8.86 8.86 0 0 1 6.31 2.62 8.88 8.88 0 0 1 2.61 6.31c0 4.92-4 8.92-8.93 8.92z" />
      </svg>
      <span className="absolute right-full mr-3 hidden md:block whitespace-nowrap rounded-lg bg-[#1A1A1A] text-white text-xs font-semibold px-3 py-1.5 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Falar no WhatsApp
      </span>
    </a>
  );
}
